// Older activities inherit the event setting until an admin chooses their state.
export function isActivityObfuscated(activity, masterEvent) {
  if (!activity) return false;
  if (typeof activity.obfuscated === 'boolean') return activity.obfuscated;
  return !!(masterEvent?.obfuscateActivities && !activity.revealed);
}

export function isActivityHidden(activity, masterEvent, isAdmin = false) {
  return !isAdmin && isActivityObfuscated(activity, masterEvent);
}

export function activityDisplayName(activity, masterEvent, isAdmin = false) {
  return isActivityHidden(activity, masterEvent, isAdmin)
    ? (activity.hint?.trim() || 'Hidden activity')
    : activity?.name;
}
